const office = {
  editor: {
    noFileId: 'No file ID provided',
    failedToStartSession: 'Failed to start editing session',
    errorLoadingDocument: 'Error loading document',
  },
};

export const en = {
  office,
};
